export default __webpack_public_path__ + "static/media/backpack3.c5b00feb.jpeg";